const initialState = {
    data: [],
  };
  
  const mieszkaniecReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_MIESZKANIEC':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default mieszkaniecReducer;